import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { JustifiedView } from '@commoncore/utils/JustifiedViewUtil';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';



export class VideosImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public customMetadata: any;
  public JsView: JustifiedView;
  public customSort: any;
  public videosnextLink = ""
  public videospreviousLink = "";
  public toppos: number = 0;
  public docheignt: number = 0;
  public sortedVideos:any= [];
  public multiSelect:any;
  private globalService:any;
  public contextMenuService: any;
  private db: IndexedDBModule;
  private dataArray:any=[];
  private indexDBdata:any="";
  containerHeightCalc:any;
  static singleInstance:any = null;
  public currentPageNo = 0;
  public previousPageNo = -1;
  paginationService: any;
  sessionStorageService:any;
  

  constructor(globalService) {
    this.globalService = globalService;
    this.setHandler(globalService);
  }

  public setHandler(globalService) {
    this.router=globalService.getRouterRef();
		this.http=globalService.getHttpClientRef();
		this.universalService=globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.JsView = new JustifiedView(this.universalService);
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.db = IndexedDBModule.getInstance(globalService);
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.paginationService = globalService.getPaginationServiceRef();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
  }

  public static getInstance(connectionService): VideosImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new VideosImplementation(connectionService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  sortVideos(videosList) {
    var sortParam = localStorage.sharePublicSort.includes("fileCreatedDate")? "createdDate" : "uploaded";
    var array = this.customSort.sortByDates(videosList,this.sortedVideos,this.universalService.sharedVideos,sortParam);
    this.sortedVideos = array[0];
    this.universalService.objectsPreviewArray = array[1];
    this.universalService.showLoader = false;
    AppEvents.virtualDOMObservable.next({"updateVDOM":true})
  }

  sortByName(videosList,sortingOrder){
    var array  = this.customSort.sortByNames(videosList,this.sortedVideos,sortingOrder)
    this.sortedVideos = array[0];
    this.universalService.sortByNameArray = array[0];
    this.universalService.objectsPreviewArray = array[1];
    this.universalService.loadGridView = true;
    if(this.sortedVideos.length == 0){
      this.universalService.emptyTab = true;
      this.universalService.showLoader = false;
      return
    }else{
      this.universalService.emptyTab = false;
    }
    AppEvents.virtualDOMObservable.next({"updateVDOM":true})
    setTimeout(() => {
      this.universalService.showLoader = false;  
    }, 10);
  }



  async decideSortOrder(url) {
    
    this.videosnextLink = "";
    this.videospreviousLink = "";
    this.universalService.showJustifiedLayout = false;
    let sortingType = this.universalService.sharePublicSortSetting();
    this.sessionStorageService.setSharePublicSortPropName(sortingType);
    this.universalService.objectsPreviewArray = [];
    this.universalService.sortByNameArray = [];
    this.currentPageNo = 0;
    this.previousPageNo = -1;
    this.paginationService.LOCAL_DB = {}
    this.sortedVideos = [];
    this.indexDBdata = await this.checkDataIndexDB(url);
    let sortingOrder = "asc";
    if(url.includes("%2D"))
      sortingOrder = "desc";
    if(!this.indexDBdata) {
      this.universalService.showLoader = true;
      this.getVideosApi(url,sortingOrder);
    } else {
      this.paginationService.spliceAndSaveDataInLocalDB(this.indexDBdata["objects"]);
      this.setNextAndPreviousLinks(this.indexDBdata);
      this.getVideos(this.paginationService.getBufferDataForNextPage(this.currentPageNo),sortingOrder);
      this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
      // this.getVideos(this.indexDBdata);

    }
  }

  getIndexDBStoreName(url) {

    if (url.includes("sort=%2BobjectName")) {
      return 'VideosMetadata_ObjectName';
    } else if (url.includes("sort=%2DfileCreatedDate")) {
      return 'VideosMetadata_FileCreatedDate';
    } else if (url.includes("sort=%2DcreatedDate")) {
      return 'VideosMetadata_CreatedDate';
    }else if (url.includes("sort=%2DobjectName") ) { //|| this.photoNameVisible
      return 'VideosMetadata_ObjectName_Desc';
    } else if (url.includes("sort=%2BfileCreatedDate") ) { //|| this.photoDateVisible
      return 'VideosMetadata_FileCreatedDate_Asc';
    } else if (url.includes("sort=%2BcreatedDate") ) {
      return 'VideosMetadata_CreatedDate_Asc';
    }
    return 'VideosMetadata_ObjectName';
  }

  async checkDataIndexDB(url) {
    if(this.universalService.activeRepo == ActiveRepo.SHARE)
      return false
    this.universalService.currentOpenIndexDBStoreforFile = storeName;
    this.universalService.currentOpenIndexDBStoreforFolder = "";
    this.universalService.photoLowerBound = 0;
    this.universalService.photoNameVisibleData = 0;
    this.universalService.photoDateVisibleData = 0;
    var storeName = this.getIndexDBStoreName(url);
    var result = await this.db.getAllData(storeName,"VideoImplementation");
    
    if (result) {
      var nextData = await this.db.getByKey('NextLink', storeName);
      var suc = {
        "objects": result
      };
      if(nextData != undefined && nextData['nextLink']) {
        suc['nextLink'] = nextData['nextLink'];
      }
      return suc;
    }
    return false;
  }


  saveToIndexDB (url, suc) {
    if(this.universalService.activeRepo == ActiveRepo.SHARE)
      return ;
    this.dataArray = suc['objects'];
    var storeName = this.getIndexDBStoreName(url);

    this.db.bulkAdd(storeName, this.dataArray);

    if (suc['nextLink']) {
      var nextLinkObj = {
        'storeName': storeName,
        'nextLink': suc['nextLink']
      };
      this.db.update('NextLink', nextLinkObj);
    } else {
      this.db.deleteByKey("NextLink",storeName);
    }
  }

  getVideosApi(url,sortingOrder) {
    this.http.get(url).subscribe(
      suc => {
        this.paginationService.spliceAndSaveDataInLocalDB(suc["objects"]);
        this.setNextAndPreviousLinks(suc);
        this.getVideos(this.paginationService.getBufferDataForNextPage(this.currentPageNo),sortingOrder);
        this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        this.saveToIndexDB (url, suc);
      },
      err => {
        this.universalService.showErrorMessage(err);
      }
    )
  }

  setNextAndPreviousLinks(suc){
    if (suc["nextLink"]) {
      this.videosnextLink = suc["nextLink"]
      if (this.videosnextLink.includes("sort=")) {
        if (this.videosnextLink.includes("sort=+")) {
          this.videosnextLink=this.videosnextLink.replace("sort=+", "sort=%2B")
        }else if (this.videosnextLink.includes("sort=-")) {
          this.videosnextLink=this.videosnextLink.replace("sort=-", "sort=%2D")
        }
      }
    } else {
      this.videosnextLink = ""
    }
  }

  async getVideos(objects,sortingOrder) {
    if(objects.length == 0){
      this.universalService.emptyTab = true;
      this.universalService.showLoader = false;
      this.universalService.showSortButtons = false;
      return
    }else{
      this.universalService.emptyTab = false;
      this.universalService.showSortButtons = true;
    }
    this.universalService.scrollToTopIcon = false;
    this.videospreviousLink = "";
    
    if (this.sortedVideos.length == 0) {
      var videosList = await this.customMetadata.segregateData(objects,"videos");
    
      if(this.universalService.nameSort){
        await this.sortByName(videosList,sortingOrder)
      }else{
        await this.sortVideos(videosList);
      }
      this.universalService.reBindingRequied = false;
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.multiSelect.bindMultiSelectLibrary(".videos-wrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
      this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
      AppEvents.multiSelectEvent.next({"dataArray":this.sortedVideos})
      this.setHeightForView();
    }
  }

  setHeightForView(){
    if(this.universalService.virtualGridEnabled) return;
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight?collapsedHeight:0
    if (!this.universalService.isMobileDevice) {
      setTimeout(() => {
        this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],69);
        this.containerHeightCalc.calculateHeight('.all-files-grid-main',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],69);
      }, 500);
    }

    if (this.universalService.isMobileDevice) {
      setTimeout(() => {
        this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container','.pseudo-audiominiplayer'],(77 + collapsedHeight))
      }, 500);
    }
  }


  async createUrlForNextLink(docheignt, toppos, url) {
    if (toppos == 0) {
      this.universalService.scrollToTopIcon = false;
    } else {
      let sortingOrder = "asc";
      if(url.includes("%2D"))
        sortingOrder = "desc";
      else if(this.universalService.activeRepo == ActiveRepo.SHARE && localStorage.shareRepoShareViewType == "gridView" &&  localStorage.sharePublicSort.includes("%2D"))
        sortingOrder = "desc";
      this.universalService.scrollToTopIcon = true;
      let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)
      
      if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
        this.previousPageNo = this.currentPageNo;
        setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
          this.currentPageNo ++;
          let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
          await this.appendData(objList,sortingOrder);
          this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        }, this.paginationService.bufferTimeoutForFetchingData);
      }
      if (checkIfContaineris95PercScrolled && this.videosnextLink != "" && this.videospreviousLink != this.videosnextLink) {
        this.videospreviousLink = this.videosnextLink;
        this.universalService.showLoader = true;
        this.getNextPageData(url,sortingOrder);
      }
    }
  }
  
  getNextPageData(url,sortingOrder) {
    this.http.get(url).subscribe(
      async nextPageData => {
        if(nextPageData["objects"] && !this.paginationService.LOCAL_DB[this.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
          let bufferDataPresent = this.paginationService.checkIfBufferDataIsPresent();
          if(!bufferDataPresent){
            this.currentPageNo = Object.keys(this.paginationService.LOCAL_DB).length;
            this.previousPageNo = this.currentPageNo - 1;
            this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
            this.setNextAndPreviousLinks(nextPageData);
            let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
            await this.appendData(objList,sortingOrder);
            this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo);
            return;
          }
        }
        this.universalService.showLoader = false;
        this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
        this.setNextAndPreviousLinks(nextPageData);
      },
      err => {
        this.universalService.showErrorMessage(err);
      }
    )
  }

  async appendData(objectsList,sortingOrder) {
    if (objectsList != undefined && objectsList.length > 0 && this.universalService.emptyTab) {
      this.universalService.emptyTab = false;
    }
    var videosList = this.customMetadata.segregateData(objectsList, "videos");
    if(videosList.length>0 && this.universalService.reBindingRequied){
      setTimeout(() => {
        this.multiSelect.bindMultiSelectLibrary(".videos-wrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
      }, 100);
    }
    if (this.universalService.nameSort) {
      await this.sortByName(videosList,sortingOrder)
    } else {
      await this.sortVideos(videosList);
    }
    AppEvents.multiSelectEvent.next({"dataArray":this.sortedVideos});
    
  }
}